import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/workshop/workshop_checkers`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}





function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_checkers/${id}`, options)
    .then(response => {
      let checkers = jsona.deserialize(response.data);
      delete checkers.links;
      return checkers;
    });
}

function add(checkers) {
  
  console.log(checkers);
  const payload = jsona.serialize({
    stuff: checkers,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/workshop/workshop_checkers`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function update(checkers) {
  const payload = jsona.serialize({
    stuff: checkers,
    includeNames: []
  });

  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.patch(`${url}/workshop/workshop_checkers/${checkers.id}`, payload, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {``
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/workshop/workshop_checkers/${id}`, options);
}



// function last_no() {
//   const options = {
//     headers: {
//       'Accept': 'application/vnd.api+json',
//       'Content-Type': 'application/vnd.api+json',
//     }
//   };

//   return axios.get(`${url}/checkers/last/no`, options)
//     .then(response => {
//       return response.data;
//     });
// }


export default {
  list,
  get,
  add,
  update,
  destroy
};

